import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navigation from './Navigation';
import { useAuth } from '@/stores/authStore';
import { usePermissions } from '@/hooks/usePermissions';
import { useTokenRefresh } from '@/hooks/useTokenRefresh';
import { Sheet, SheetContent } from '@/components/ui/sheet';

interface LayoutProps {
  children?: React.ReactNode;
}

export default function Layout({ children }: LayoutProps) {
  const { isAuthenticated } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  usePermissions();
  
  // Initialize token refresh mechanism
  useTokenRefresh();

  if (!isAuthenticated) {
    return <Outlet />;
  }

  return (
    <div className="min-h-screen bg-background">
      {/* Mobile Sidebar Overlay */}
      <div className="fixed top-0 left-0 right-0 z-50">
        <Navigation onMenuClick={() => setSidebarOpen(true)} />
      </div>
      
      <div className="flex pt-16">
        {/* Desktop Sidebar */}
        <div className="hidden lg:block sticky top-16 h-[calc(100vh-4rem)]">
          <Sidebar />
        </div>
        
        {/* Mobile Sidebar */}
        <Sheet open={sidebarOpen} onOpenChange={setSidebarOpen}>
          <SheetContent side="left" className="w-[280px] p-0 h-full flex flex-col">
            <div className="flex items-center justify-between p-4 border-b flex-shrink-0">
              <h2 className="text-lg font-semibold">Menu</h2>
            </div>
            <div className="flex-1 overflow-y-auto min-h-0">
              <Sidebar onMobileClose={() => setSidebarOpen(false)} />
            </div>
          </SheetContent>
        </Sheet>
        
        {/* Main Content */}
        <div className="flex-1 min-w-0">
          <main className="p-4 sm:p-6 lg:p-8">
            {children || <Outlet />}
          </main>
        </div>
      </div>
    </div>
  );
} 